export const OPERATION_STARTED ="OPERATION_STARTED";
export const OPERATION_FAILED ="OPERATION_FAILED";
export const OPERATION_COMPLETED ="OPERATION_COMPLETED";